import loadable from "@loadable/component";

loadable.lib(
  () => import(/* webpackChunkName: "rgpd-tools" */ "react-gtm-module"),
  { ssr: false });

loadable.lib(
  () => import(/* webpackChunkName: "rgpd-tools" */ "@use-cookie-consent/react"),
  { ssr: false });

// @ts-ignore
loadable(() => import(/* webpackChunkName: "rgpd-tools" */"./cookie-banner.scss"), { ssr: false });

export const CookieConsentProvider = loadable(
  () => import(/* webpackChunkName: "rgpd-tools" */ "@use-cookie-consent/react"),
  { ssr: false, resolveComponent: module => module.CookieConsentProvider });

export const RGPDProvider = loadable(
  () => import(/* webpackChunkName: "rgpd-tools" */ "./cookie-provider"),
  { ssr: false });

export const RGPDBanner = loadable(
  () => import(/* webpackChunkName: "rgpd-tools" */ "./cookie-banner"),
  { ssr: false });
